import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestRunMarketingFlows } from "./runMarketingFlows.request";

const useRunMarketingFlows = (
  options?: MutationOptions<unknown, ApiServiceError<ApiError>, void>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestRunMarketingFlows,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({ queryKey: ["marketing", "flows"] });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useRunMarketingFlows;
